import { ReportsAnalytics } from "@/components/ReportsAnalytics";

export default function ReportsPage() {
  return <ReportsAnalytics />;
}


